export default __webpack_public_path__ + "static/media/CoursePageProfile.d844195f.png";